import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	TRACK_STATE_STATUS,
	TRACK_STATUS_OPEN
} from "../config/constants";
import Lifts from "./Lifts";
import { getServerTrackStatusToClient} from "../helpers/map";
import { connectorsData } from "../data/connectorsData";
import { connectorCondition, getConnectorTracksDepends } from "../helpers/conditions";
import { localTracksData } from "../data/tracks";
import MapMarkers from "./markers/MapMarkers";

class Map extends Component {
	state = {
		tracksState: TRACK_STATE_STATUS,
		tracksOpen: TRACK_STATUS_OPEN
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		//console.log('[Map]: did update and rerender');
	}

	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return this.props.revision !== nextProps.revision;
	}

	render() {
		const { tracksState, serverTracksData } = this.props;

		return (
			<>
				{Object.keys(localTracksData).map(trackName => {
					// Debug для green треків
					if (trackName.includes('Green')) {
						console.log('🟢 Green track:', trackName, {
							serverExists: typeof serverTracksData[trackName] !== 'undefined',
							isShow: serverTracksData[trackName]?.isShow,
							localExists: typeof localTracksData[trackName] !== 'undefined'
						});
					}

					if (typeof serverTracksData[trackName] === 'undefined' ||
						!serverTracksData[trackName].isShow ||
						typeof localTracksData[trackName] === 'undefined'
					) {
						//console.log('Track ' + trackName + ' - skipped');
						return null;
					}

					const trackData = serverTracksData[trackName];
					const { status } = trackData;
					const connector = connectorsData[trackName];
					const TrackComponent = localTracksData[trackName].component;
					const ConnectorComponent = (connector ? connector.component : null);
					const trackProps = {
						id: trackName,
						state: tracksState,
						workState: getServerTrackStatusToClient(status),
						onLabelClick: (event, ref, trackId) => this.props.onClickOnLabel(event, ref, trackId)
					};

					return (
						<React.Fragment key={'trackConnector' + trackName}>
							{connector && <ConnectorComponent
								state={tracksState}
								workState={connectorCondition(getConnectorTracksDepends(connector.dependsOn, serverTracksData))}
							/>}
							<TrackComponent {...trackProps}/>
						</React.Fragment>
					)
				})}

				<Lifts activeLiftId={this.props.activeLiftId}/>
				<MapMarkers/>
			</>
		);
	}
}

Map.propTypes = {
	onClickOnLabel: PropTypes.func,
	tracksState: PropTypes.string,
	serverTracksData: PropTypes.object
};

export default Map;
